import { BreadCrumbModel } from './breadcrumb.model';

export class BreadCrumbPropertyModel {

    breadCrumbs: BreadCrumbModel[];
    source: string;
}